import {
    SAVE_CLIENT_SIDE_FILTERS,
    CLEAR_FILTERS
} from 'typeConstants';
import { filters as initialState } from '../initialState.tsx';

const filters = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_CLIENT_SIDE_FILTERS:
            return {
                ...state,
                clientSideFilters: action.payload
            };
          case CLEAR_FILTERS:
            return {
              ...state,
              clearFilters: state.clearFilters ? 0 : 1
            };
        default:
            return state;
    }
};

export default filters;